var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhonenumberWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.5,
    height: 19.5,
    viewBox: "0 0 19.5 19.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160687",
    "data-name": "Group 160687",
    transform: "translate(-464.283 -160.77)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160597",
    "data-name": "Group 160597",
    transform: "translate(465.033 161.52)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_156",
    "data-name": "Ellipse 156",
    cx: 0.504,
    cy: 0.504,
    rx: 0.504,
    ry: 0.504,
    transform: "translate(3.644 13.638)",
    fill: "#787f88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "phone1",
    d: "M7.677,17.318a13.764,13.764,0,0,0,8.075,2.6h2.079a2.077,2.077,0,0,0,2.079-2.08h0V16.575a1.042,1.042,0,0,0-.787-1.009l-4.086-1.018a1.047,1.047,0,0,0-1.079.381l-.893,1.195a.977.977,0,0,1-1.114.354A11.107,11.107,0,0,1,5.36,9.885.974.974,0,0,1,5.713,8.77l1.194-.894a1.023,1.023,0,0,0,.38-1.08L6.262,2.708A1.041,1.041,0,0,0,5.253,1.92H3.989A2.077,2.077,0,0,0,1.91,4h0v2.08a13.766,13.766,0,0,0,2.9,8.487",
    transform: "translate(-1.91 -1.92)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhonenumberWhiteIcon);
export default __webpack_public_path__ + "static/media/phonenumber-white-icon.ba5da37421851c4f3ba31938f9146515.svg";
export { ForwardRef as ReactComponent };